/**
 * Created by RKL on 07/09/2015.
 */
define('adminKitDetailsController',[
  'module',
  'underscore',
  'app',
  'bootbox',
  'adminKitDetailsView',
  'emptyView',
  'kitDetailTabController',
  'adminAssayController',
  'adminKitlController',
  'adminKitcController',
  'rolesMixin',
  'settings',
  'entities/kits'
], function(
  module,
  _,
  App,
  bootbox,
  View,
  EmptyView,
  kitDetailTabController,
  adminAssayController,
  adminKitlController,
  adminKitcController
) {
  'use strict';

  var KitsDetailsController = {
    fetchKit: function(data) {
      var that = this,
          emptyView = new EmptyView(),
          contentRegion = App.regions.getRegion('main').currentView.getRegion('content');

      contentRegion.show(emptyView);

      this.data = data;
      if (this.model && this.model.get('secId') === data.secId) {
        this.showKit(data);
      } else {
        this.model = App.request('kit:model', {secId: data.secId});
        this.model.fetch().done(function() {
          if (contentRegion) {
            that.showKit(data);
          }
        });
      }
    },

    showKit: function(data) {
      var view = new View({model: this.model, data: data});

      this.view = view;
      data.model = this.model;

      App.regions.getRegion('main').currentView.getRegion('content').show(view);

      this.displayTabs(data);

      view.listenTo(view, 'click:tab', _.bind(this.onTabClick, this));
      view.listenTo(App, 'kit:header:rerender', _.bind(this.onHeaderChange, this));
    },

    onHeaderChange: function (kit) {
      this.view.onHeaderChange(kit);
    },

    displayTabs: function(data) {
      for (var region in this.view.regions) {
        if (App.regions.getRegion('main') && App.regions.getRegion('main').currentView &&
            App.regions.getRegion('main').currentView.getRegion('content') &&
            App.regions.getRegion('main').currentView.getRegion('content').currentView &&
            App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion(region)) {
          var currentViewRegion = App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion(region).currentView;
          if(currentViewRegion) {
            currentViewRegion.destroy();
          }
        }
      }

      if (data.tab) {
        switch (data.tab.name) {
          case 'kitl':
            adminKitlController.showKitlList(data);
            break;
          case 'kitc':
            adminKitcController.showKitcList(data);
            break;
          case 'assay':
            adminAssayController.showAssayList(data);
            break;
          default:
            kitDetailTabController.showTab(data);
            break;
        }
      } else {
        kitDetailTabController.showTab(data);
      }

      data.model = this.model;
      this.tab = data.tab;
    },

    onTabClick: function(tab) {
      if (this.data.tab !== tab || this.data.secId) {
        this.data.tab = tab;
        this.data.secId = null;

        this.displayTabs(this.data);
        App.navigate('admin/kits/' + this.model.get('secId') + '/' + tab.name);
      }
    }
  };

  module.exports = KitsDetailsController;
});
